// src/services/socket.js
import io from 'socket.io-client'

// Configuração otimizada do Socket.IO com fallback para polling
const socket = io('https://chat-api.manyconvert.com', {
  transports: ['websocket', 'polling'], // Polling como fallback quando WebSocket falhar
  reconnection: true,
  reconnectionDelay: 500, // Começar com 500ms
  reconnectionDelayMax: 5000, // Máximo de 5 segundos entre tentativas
  reconnectionAttempts: Infinity, // Tentar reconectar infinitamente
  timeout: 20000, // Timeout de 20 segundos
  forceNew: false,
  upgrade: true,
})

export default socket
